/** Standard Google Calendar event fields shown in campaign variable mapping UI. */
export const CALENDAR_STANDARD_FIELD_OPTIONS = [
  { key: 'start_date', label: 'Fecha' },
  { key: 'start_time', label: 'Hora' },
  { key: 'location', label: 'Ubicación' },
  { key: 'summary', label: 'Nombre del evento' },
  { key: 'meeting_link', label: 'Enlace de reunión' },
] as const;

export const CALENDAR_STANDARD_FIELD_KEYS = CALENDAR_STANDARD_FIELD_OPTIONS.map(
  (f) => f.key,
);

/** True if a backend field key is standard or a description variable from the calendar. */
export function isAllowedCalendarFieldKey(
  key: string,
  descriptionVarKeys: string[] = [],
): boolean {
  const normalized = key.toLowerCase().trim();
  if ((CALENDAR_STANDARD_FIELD_KEYS as readonly string[]).includes(normalized)) {
    return true;
  }
  return descriptionVarKeys.some((k) => k.toLowerCase() === normalized);
}

/** Labels in mapping that are not available from the loaded calendar events. */
export function findInvalidCalendarMappingLabels(
  mappingLabels: string[],
  availableLabels: string[],
): string[] {
  const allowed = new Set(availableLabels);
  return mappingLabels.filter((label) => label?.trim() && !allowed.has(label));
}

export function calendarFieldKeyToLabel(key: string): string {
  const found = CALENDAR_STANDARD_FIELD_OPTIONS.find((f) => f.key === key);
  return found ? found.label : key;
}

export function calendarFieldLabelToKey(label: string): string {
  const found = CALENDAR_STANDARD_FIELD_OPTIONS.find((f) => f.label === label);
  return found ? found.key : label;
}

/** Maps template variable names (lowercase) to backend row_data keys. */
export const CALENDAR_LABEL_TO_FIELD_KEY: Record<string, string> = {
  ...Object.fromEntries(
    CALENDAR_STANDARD_FIELD_OPTIONS.map((f) => [f.label.toLowerCase(), f.key]),
  ),
  fecha: 'start_date',
  date: 'start_date',
  'fecha del evento': 'start_date',
  hora: 'start_time',
  time: 'start_time',
  'hora del evento': 'start_time',
  ubicacion: 'location',
  ubicación: 'location',
  location: 'location',
  'ubicacion del evento': 'location',
  'ubicación del evento': 'location',
  start_date: 'start_date',
  start_time: 'start_time',
  titulo: 'summary',
  título: 'summary',
  nombre: 'summary',
  'nombre del evento': 'summary',
  event_name: 'summary',
  summary: 'summary',
  meeting: 'meeting_link',
  meet: 'meeting_link',
  enlace: 'meeting_link',
  link: 'meeting_link',
  'enlace de reunion': 'meeting_link',
  'enlace de reunión': 'meeting_link',
  meeting_link: 'meeting_link',
};

/** Recognized calendar variable names for validation (lowercase). */
export const CALENDAR_STANDARD_VAR_NAMES = new Set(
  Object.keys(CALENDAR_LABEL_TO_FIELD_KEY),
);
